/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbRespMainContent_viewer = {
    readonly " $fragmentRefs": FragmentRefs<"SbRespRefineMenuSelector_viewer" | "SbRespSearchResultContainer_viewer" | "SbSharedRelatedItems_viewer" | "SbRespRefineTopNav_viewer">;
    readonly " $refType": "SbRespMainContent_viewer";
};
export type SbRespMainContent_viewer$data = SbRespMainContent_viewer;
export type SbRespMainContent_viewer$key = {
    readonly " $data"?: SbRespMainContent_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"SbRespMainContent_viewer">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SbRespMainContent_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SbRespRefineMenuSelector_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbRespSearchResultContainer_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRelatedItems_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbRespRefineTopNav_viewer",
      "args": null
    }
  ]
};
(node as any).hash = 'df1fefeb5996574703c911aa2615c747';
export default node;
